import React, {h, Component} from 'preact';
import AutoCompleteInput from '../../AutoCompleteInput';
import './request-questions-modal.scss';

export default class SellQuestionsModal extends Component {
    state = {
        contract_ending: {},
        competing_agents: {},
        competing_agents_name: {},
        competing_agents_brokerage: {},
        also_buying: {},
        agent_questions: {},
        note: {},
        changed: false
    };

    modalRef;
    autoCompleteRef;
    autoCompleteAgentsRef;

    ENDPOINT_ADDRESS = 'update-req-thankyou-json';
    FLOW_NAME = 'SellRequest';
    EVENT_SKIP_ANSWERS = 'SellReceiptSkip';
    EVENT_SUBMIT_ANSWERS = 'SellReceiptDone';

    STEPS = {};

    contract_ending = {
        text: 'When is the contract with your current agent ending?',
        suggestions: ['Within a month', '1 - 3 months', '3+ months'],
        onAnswer: answer => {
            if (!!answer) {
                this.updateAnswers('contract_ending', 'contractEndingNote', answer);
            } else if (!!this.state.note.value) {
                this.setState({contract_ending: {}});
            }
        },
        subQuestion: 'none',
        type: 'select'
    };
    competing_agents = {
        text: 'Are you currently speaking with agents?',
        onAnswer: answer => {
            if (!answer) {
                this.setState({
                    competing_agents_name: {},
                    competing_agents_brokerage: {}
                });
            }
            this.updateAnswers('competing_agents', 'req.spokeWithCompetingAgents', answer);
        },
        subQuestion: 'competing_agents_name',
        type: 'boolean',
        suggestions: ['Yes, I am', 'No, I am not']
    };
    competing_agents_name = {
        text: "What is the Realtor's name and brokerage?",
        subText: "This is so we don't invite them to submit a proposal.",
        onAnswer: answer => {
            if (this.state.competing_agents.value !== true) {
                this.setState({
                    competing_agents: {
                        property: 'req.spokeWithCompetingAgents',
                        value: !!answer
                    }
                });
            }
            this.updateAnswers('competing_agents_name', 'req.competingAgents', answer);
        },
        inputName: 'competingAgents',
        maxLength: 149,
        placeholder: 'Agent name',
        type: 'autocomplete-agent',
        nextSubQuestion: 'competing_agents_brokerage' //the reference to the sub question to be rendered next
    };
    competing_agents_brokerage = {
        // the question itself
        text: '',
        subText: '',
        onAnswer: answer => {
            this.updateAnswers(
                'competing_agents_brokerage', // the question reference to be stored on the object which will be turned into the post request
                'req.competingBrokerages',
                answer
            );
        },
        inputName: 'competingBrokerage',
        maxLength: 149,
        placeholder: 'Brokerage name',
        type: 'autocomplete-brokerage'
    };
    also_buying = {
        text: 'Are you also planning to buy a home?',
        onAnswer: answer => {
            this.updateAnswers('also_buying', 'req.alsoBuying', answer);
        },
        type: 'boolean',
        subQuestion: 'none',
        suggestions: ['Yes, I am', 'No, I am not']
    };
    agent_questions = {
        text: "Do you have any questions you'd like agents to answer in their proposal?",
        subQuestion: 'note',
        onAnswer: answer => {
            if (!answer) {
                this.setState({note: {}});
            }
            this.updateAnswers('agent_questions', null, answer);
        },
        type: 'boolean',
        suggestions: ['Yes, I do', 'No, I do not']
    };
    note = {
        text: ' ',
        suggestions: [
            'What sets you apart from other agents?',
            'How will you successfully market my home?',
            'What are your insights into market trends for my local area?'
        ],
        onAnswer: answer => {
            if (!!answer) {
                this.setState({agent_questions: {value: true}});
                this.updateAnswers('note', 'note', 'Seller has the following question(s) for the agents: ' + answer);
            } else if (!!this.state.note.value) {
                this.setState({note: {}});
            }
        },
        inputName: 'note',
        type: 'select'
    };

    constructor(props) {
        super(props);

        if (props.onMarket) {
            this.STEPS = {contract_ending: this.contract_ending};
        } else {
            this.STEPS = {competing_agents: this.competing_agents};
        }

        this.STEPS.competing_agents_name = this.competing_agents_name;
        this.STEPS.competing_agents_brokerage = this.competing_agents_brokerage;
        this.STEPS.also_buying = this.also_buying;
        this.STEPS.agent_questions = this.agent_questions;
        this.STEPS.note = this.note;
    }

    componentWillMount() {
        if (this.props.alsoBuying) {
            delete this.STEPS.also_buying;
        }
    }

    initAutoComplete = (searchPhrase, callback) => {
        if (this.state.competing_agents.value !== true) {
            this.setState({
                competing_agents: {
                    property: 'req.spokeWithCompetingAgents',
                    value: true
                }
            });
            this.state.changed = true;
        }
        const results = this.props.brokerages.filter(
            brokerage => brokerage.match(new RegExp(searchPhrase, 'gi')) //Aleks improve this with a better array search, such as lodash's _.filter.
        );
        callback(results);
    };

    fetchAutocompleteCompeteAgents = (searchPhrase, callback) => {
        if (this.state.competing_agents.value !== true) {
            this.setState({
                competing_agents: {
                    property: 'req.spokeWithCompetingAgents',
                    value: true
                }
            });
            this.state.changed = true;
        }
        $.get('getRealtorList-json', {
            state: this.props.state,
            city: this.props.city,
            phrase: searchPhrase
        }).then(data => {
            callback(data['realtorNameList']);
        });
    };

    updateAnswers = (question, property, value) => {
        this.setState({[question]: {value, property}, changed: true});
    };

    forceReload = () => {
        if (this.state.changed) {
            window.location.reload();
        }
    };

    submitQuestions = () => {
        const params = {requestId: this.props.requestId};
        this.updateAnswers('competing_agents_name', 'req.competingAgents', $('input[name="competingAgents"]').val());
        this.updateAnswers(
            'competing_agents_brokerage',
            'req.competingBrokerages',
            $('input[name="competingBrokerage"]').val()
        );
        console.log('>>', JSON.stringify(this.state));
        Object.keys(this.state).forEach(key => {
            const entry = this.state[key];
            if (!!entry.property) {
                params[entry.property] = entry.value;
            }
        });
        $.post(this.ENDPOINT_ADDRESS, params);
    };

    handleModalClose = () => {
        if (this.props.onModalClose) {
            setTimeout(() => {
                this.props.onModalClose();
                this.forceReload();
            }, 1000);
        }
    };

    renderQuestions = (question, index) => {
        if (!question || !this.STEPS[question]) return;

        const questionNumber = typeof index !== 'undefined' ? index + 1 : null;
        let {text, subText, inputName, type, onAnswer, suggestions, subQuestion, nextSubQuestion, ...rest} = this.STEPS[
            question
        ];

        const isQuestionAnsweredYes = (this.state[question] || {}).value === true;
        const isQuestionAnsweredNo = (this.state[question] || {}).value === false;
        const isQuestionUnanswered = (!isQuestionAnsweredYes) && (!isQuestionAnsweredNo);

        if (isQuestionAnsweredNo || isQuestionUnanswered) {
            subQuestion = '';
        }

        return (
            <div className={'question ' + question} key={`${question}-${!!questionNumber || 0}`}>
                {!!text && (
                    <div className="question-title">
                        {text} {!!subText && <div className="question-subtitle">{subText}</div>}
                    </div>
                )}
                {type === 'boolean' && (
                    <div className="question-answer-container">
                        <div
                            className={`answer-button radio${isQuestionAnsweredYes ? ' active' : ''}`}
                            onClick={() => onAnswer(true)}>
                            {suggestions ? suggestions[0] : 'Yes'}
                        </div>
                        <div
                            className={`answer-button radio${isQuestionAnsweredNo ? ' active' : ''}`}
                            onClick={() => onAnswer(false)}>
                            {suggestions ? suggestions[1] : 'No'}
                        </div>
                    </div>
                )}
                {type === 'string' && (
                    <div className="question-answer-container">
                        <input
                            type="text"
                            className="answer-input"
                            name={inputName}
                            {...rest}
                            onChange={({target: {value}}) => onAnswer(value)}
                        />
                    </div>
                )}
                {type === 'autocomplete-brokerage' && (
                    <div className="question-answer-container autocomplete">
                        <AutoCompleteInput
                            onTextChange={this.initAutoComplete}
                            inputProps={{
                                className: 'answer-input',
                                name: inputName,
                                ...rest
                            }}
                            onSelect={onAnswer}
                        />
                    </div>
                )}
                {type === 'autocomplete-agent' && (
                    <div className="question-answer-container">
                        <AutoCompleteInput
                            onTextChange={this.fetchAutocompleteCompeteAgents}
                            inputProps={{
                                className: 'answer-input',
                                name: inputName,
                                ...rest
                            }}
                            onSelect={onAnswer}
                        />
                        {!!this.STEPS[nextSubQuestion] && (
                            <AutoCompleteInput
                                onTextChange={this.initAutoComplete}
                                inputProps={{
                                    className: 'answer-input',
                                    name: this.STEPS[nextSubQuestion].inputName,
                                    ...this.STEPS[nextSubQuestion]
                                }}
                                onSelect={this.STEPS[nextSubQuestion].onAnswer}
                            />
                        )}
                    </div>
                )}
                {type === 'select' && !!suggestions && (
                    <div className="question-answer-container select">
                        <div className="select-wrapper icon-arrow-drop-down">
                            <select className="answer-input" onChange={({target: {value}}) => onAnswer(value)}>
                                <option value="">Select one...</option>
                                {suggestions.map(item => (
                                    <option value={item} key={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                {subQuestion && type != 'competing_agents_name' && (
                    <div className="sub-question">{this.renderQuestions(subQuestion || nextSubQuestion)}</div>
                )}
            </div>
        );
    };

    render() {
        return (
            <div
                ref={ref => (this.modalRef = ref)}
                className="modal nu-modal fade in request-questions-popup"
                role="dialog"
                style="display: block;">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content side-by-side">
                            <div className="modal-header text-center">
                                <h4>Thousands of happy home buyers have used UpNest</h4>
                                <div className="review-block">
                                    <div className="stars">
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                    </div>
                                    <p className="review-content">
                                        “UpNest showed me multiple agents active in my area, some of them offered me
                                        thousands of dollars in rebates.”
                                    </p>
                                    <p className="review-footer">
                                        <b>Elizabeth Licata</b>
                                        <br />
                                        From Google Reviews
                                    </p>
                                </div>
                            </div>

                            <div className="modal-body">
                                <p className="status-message">
                                    Thank you!
                                    Your request has been submitted.
                                </p>
                                <h4 className="form-header">Tell us a bit more to find the perfect agent</h4>
                                <div className="questions-container">
                                    {Object.keys(this.STEPS)
                                        .filter(key => !!this.STEPS[key].subQuestion)
                                        .map((step, index) => this.renderQuestions(step, index))}
                                </div>
                                <div className="modal-footer">
                                    <div className="modal-actions-container row">
                                        <button
                                            type="button"
                                            className={`btn btn-default pull-right${
                                                this.state.changed ? '' : ' disabled'
                                            }`}
                                            id="prefillCommTiers"
                                            onClick={() => {
                                                trackEvent('Flow', this.FLOW_NAME, this.EVENT_SUBMIT_ANSWERS).withGA();
                                                this.submitQuestions();
                                                this.handleModalClose();
                                            }}>
                                            Submit
                                            <i className="icon-arrow-direct-right" />
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-cancel pull-right"
                                            aria-label="Close"
                                            onClick={() => {
                                                trackEvent('Flow', this.FLOW_NAME, this.EVENT_SKIP_ANSWERS).withGA();
                                                this.handleModalClose();
                                            }}>
                                            Skip for now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
